import React from 'react';
import { DateTime } from 'luxon';
import { useFlipOIDC } from '../../components/FlipOIDC';

export default function Intro() {
  const { me } = useFlipOIDC();

  const label = DateTime.now().toFormat('a').toLowerCase() === 'am' ? 'morning' : 'afternoon';

  return (
    <div className="mb-16 time-attendance-intro">
      {`Good ${label} ${me.first_name}`}
    </div>
  );
}
